var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pizzatoppings",
    transform: "translate(-133.000000, -154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Both-Copy",
    transform: "translate(134.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#774518",
    strokeWidth: 2,
    fill: "#B93131",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,4 L14,26 C7.92486775,26 3,21.0751322 3,15 C3,8.92486775 7.92486775,4 14,4 Z",
    id: "Combined-Shape-Copy",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,4 L27,26 C20.9248678,26 16,21.0751322 16,15 C16,8.92486775 20.9248678,4 27,4 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#CBCBCB",
    transform: "translate(21.500000, 15.000000) scale(-1, 1) translate(-21.500000, -15.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoth);
export default __webpack_public_path__ + "static/media/Both.581add4fc001d0ce57ef6c45c68772e2.svg";
export { ForwardRef as ReactComponent };